<script lang="ts">
  import type { FieldConfig } from 'scripts/utils/types';

  // export let labelDisplay: boolean = true;
  export let values;
  export let config: FieldConfig;
  let config_start;
  let config_end;

  $: config_start = { ...config };
  $: config_end = { ...config };
  // $: console.log(values);
</script>

{#if values && !config.options.read_only}
  <div class="range-wrap">
    <svelte:component
      this={config_start.component}
      bind:value={values[0]}
      config={{ ...config_start, inputClass: 'w-100', label_display: false }}
    />
    <span class="range-sep">〜</span>
    <svelte:component
      this={config_end.component}
      bind:value={values[1]}
      config={{ ...config_end, inputClass: 'w-100', label_display: false }}
    />
  </div>
{/if}

<style>
  .range-wrap {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    width: 100%;
    min-width: 0;
  }
  .range-wrap :global(> *:not(.range-sep)) {
    flex: 1 1 0;
    min-width: 0;
  }
  .range-sep {
    flex: 0 0 auto;
    padding: 0 0.1rem;
    color: #666;
  }
</style>
